import config from 'config';
import {
  AddAndPayRazorpayStep1Resp,
  AddAndPayRazorpayStep2Resp,
  AddRazorpayStep1Resp,
  AddRazorpayStep2Resp,
  CancelRazorpayTransactionPayload,
  UseRazorpayResp,
} from 'types/transaction-razorpay';
import fetchWithToken from './provider/fetch';

const transactionsRazorpayEndPoint = (accountKey: string, sessionId: string): string =>
  `${config.COPAS_URL}/payment/ui/cip/v1/${accountKey}/session/${sessionId}/transaction/rp`;

export const daoTransactionAddRazorpayStep1Post = (
  accountKey: string,
  sessionId: string,
): Promise<AddRazorpayStep1Resp> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/addRazorPayWithoutPayment/step1`,
    method: 'POST',
    body: null,
  });

export const daoTransactionAddRazorpayStep2Post = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<AddRazorpayStep2Resp> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/addRazorPayWithoutPayment/step2`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionAddAndPayRazorpayStep1Post = (
  accountKey: string,
  sessionId: string,
): Promise<AddAndPayRazorpayStep1Resp> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/addRazorPayWithPayment/step1`,
    method: 'POST',
    body: null,
  });

export const daoTransactionAddAndPayRazorpayStep2Post = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<AddAndPayRazorpayStep2Resp> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/addRazorPayWithPayment/step2`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionUseRazorpayPost = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<UseRazorpayResp> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/pay`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionCancelRazorpayDelete = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<CancelRazorpayTransactionPayload> =>
  fetchWithToken({
    reqUrl: `${transactionsRazorpayEndPoint(accountKey, sessionId)}/cancelStep2`,
    method: 'DELETE',
    body: JSON.stringify(data),
  });
